import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunicationsContext } from '../context/CommunicationsContext.tsx';

export interface ICommunicationSearchableTypeSelectInputProps
  extends ISelectInputProps {}

export function CommunicationSearchableTypeSelectInput(
  props: ICommunicationSearchableTypeSelectInputProps,
) {
  const { ...otherProps } = props;
  const { searchableTypes } = useCommunicationsContext();
  const { t } = useTranslation();

  const options = useMemo(() => {
    return searchableTypes?.map(type => ({
      label: type.codice ?? '',
      value: type.id!,
    }));
  }, [searchableTypes]);

  return (
    <SelectInput
      options={options}
      allowClear
      placeholder={t(
        'communication-searchable.search-by-type',
        'Cerca per tipo...',
      )}
      {...otherProps}
    />
  );
}
